import gql from 'graphql-tag'

export const GET_SHIFTS = gql`
  query Shifts($filter: GetShiftsPaginationFilter) {
    shifts(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      shifts {
        data {
          shiftId
          name
          color
          shiftTime {
            shiftTimeId
            shiftId
            dates
            days
            startTime
            endTime
            createdBy
            createdOn
          }
        }
        pagination {
          total
          page
          show
          actualTotal
        }
      }
    }
  }
`

export const GET_SHIFT = gql`
  query Shift($filter: GetShiftFilter!) {
    shift(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      shift {
        shiftId
        name
        color
        shiftTime {
          shiftTimeId
          shiftId
          dates
          days
          startTime
          endTime
          createdBy
          createdOn
        }
      }
    }
  }
`

export const CREATE_SHIFT = gql`
  mutation CreateShift($input: CreateShiftInput!) {
    createShift(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createShift {
        shiftId
        name
        color
      }
    }
  }
`

export const UPDATE_SHIFT = gql`
  mutation UpdateShift($input: UpdateShiftInput!) {
    updateShift(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateShift {
        shiftId
        name
        color
      }
    }
  }
`

export const DELETE_SHIFT = gql`
  mutation DeleteShift($input: DeleteShiftInput!) {
    deleteShift(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      deleteShift {
        shiftId
        name
        color
      }
    }
  }
`
